import React from 'react';
import { Alert } from 'antd';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

const StyledBaseBanner = styled(Alert)`
  background-color: ${colors.WHITE} !important;
  border: 0px ${colors.WHITE} !important;
  box-shadow: 0px 0px 8px 2px rgba(56, 56, 56, 0.12);
`;

const Banner = ({
  type = 'info',
  closable = false,
  message,
  description,
  showIcon = true,
  icon,
  ...props
}) => {
  return (
    <StyledBaseBanner
      type="info"
      message={message}
      description={description}
      closable={closable}
      showIcon={showIcon}
      icon={icon}
      {...props}
    />
  );
};

export default Banner;
